import {
  IoCodeWorking,
  IoLogoGithub,
  
  IoLogoLinkedin,
  IoLogoVercel,
} from "react-icons/io5";
import img1 from "./images/Nft_Market.png";
import img2 from "./images/TokenSwap.png";
import img3 from "./images/Buy.png";


export const Experience = [
  {
    id: 1,
    date: "2022- present",
    iconsSrc: <IoCodeWorking />,
    title: "Working on Research Paper",
    location: "IIIT Jabalpur",
    description:
      "Currently I am working on a research paper over 'Img. processing and Blockchain in SupplyChain' under my Prof. and with a PHD Scholar at my IIIT",
  },
  {
    id: 2,
    date: "2021 - 2025",
    iconsSrc: <IoCodeWorking />,
    title: "Btech ",
    location: "IIIT Jabalpur",
    description:
      "Pursuing Btech at IIIT Jabalpur ",
  },
  {
    id: 2,
    date: " - 2016",
    iconsSrc: <IoCodeWorking />,
    title: "Student",
    location: "Kharagpur, WestBengal",
    description:
      "S.E.RLY.M.H.S.School(E.M), Kharagpur ",
  },
];

export const Projects = [
  {
    id: 1,
    name: "NFT MarketPlace",
    imageSrc: img1,
    techs: "React Js, Vercel, Thirdweb",
    github: "https://github.com/Akhil2345",
  },
  {
    id: 2,
    name: "TokenSwap  ",
    imageSrc: img2,
    techs: "React Js, Butterify,CSS",
    github: "https://github.com/Akhil2345",
  },
  {
    id: 3,
    name: "Buy Me a Coffe , A defi-app",
    imageSrc: img3,
    techs: "React Js,Hardhat, Vercel",
    github: "https://github.com/Akhil2345",
  },

];

export const SocialLinks = [
  {
    id: 1,
    iconSrc: <IoLogoGithub className="text-textBase text-3xl cursor-pointer" />,
    name: "GitHub",
    link: "https://github.com/Akhil2345",
  },
  {
    id: 1,
    iconSrc: (
      <IoLogoLinkedin className="text-blue-800 text-3xl cursor-pointer" />
    ),
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/akhil-kumar-polmarsetti-1a9569226/",
  },
  {
    id: 1,
    iconSrc: (
      <IoLogoVercel className="text-black-500 text-3xl cursor-pointer" />
    ),
    name: "Vercel",
    link: "https://vercel.com/dashboard",
  },
  
];
